import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bottomActionsArea"
}
const _hoisted_2 = ["title"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "pi pi-chevron-right" })
], -1)
const _hoisted_4 = {
  key: 1,
  class: "bottomActionsArea"
}
const _hoisted_5 = ["title"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "pi pi-chevron-right" })
], -1)
const _hoisted_7 = {
  key: 2,
  class: "bottomActionsArea"
}
const _hoisted_8 = ["title"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "pi pi-chevron-right" })
], -1)
const _hoisted_10 = ["title"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "pi pi-chevron-right" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($props.adDocFileType === 'T')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "textAndActionButton",
          title: $setup.t('proposeAnAdDocModelTitle'),
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => ($setup.openCreateModel()), ["stop"]))
        }, [
          _createElementVNode("div", null, _toDisplayString($setup.t('proposeAnAdDocModel')), 1),
          _hoisted_3
        ], 8, _hoisted_2)
      ]))
    : ($props.adDocFileType === 'S')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", {
            class: "textAndActionButton",
            title: $setup.t('proposeAnAdDocSuggestionTitle'),
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => ($setup.openCreateSuggestion()), ["stop"]))
          }, [
            _createElementVNode("div", null, _toDisplayString($setup.t('proposeAnAdDocSuggestion')), 1),
            _hoisted_6
          ], 8, _hoisted_5)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", {
            class: "textAndActionButton",
            title: $setup.t('proposeAnAdDocTitle'),
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => ($setup.openPropose()), ["stop"]))
          }, [
            _createElementVNode("div", null, _toDisplayString($setup.t('proposeAnAdDoc')), 1),
            _hoisted_9
          ], 8, _hoisted_8),
          _createElementVNode("div", {
            class: "textAndActionButton",
            title: $setup.t('askCoachingTitle'),
            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => ($setup.askCoaching()), ["stop"]))
          }, [
            _createElementVNode("div", null, _toDisplayString($setup.t('askCoaching')), 1),
            _hoisted_11
          ], 8, _hoisted_10)
        ]))
}